
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1951"}},[_c('g',{attrs:{"data-name":"Group 1950"}},[_c('path',{attrs:{"data-name":"Path 1266","d":"M12.001 2a10 10 0 11-10 10 10.01 10.01 0 0110-10m0-2a12 12 0 1012 12 12 12 0 00-12-12z","fill":"#adadad"}})]),_c('path',{attrs:{"data-name":"Path 1267","d":"M15.564 14.648h-4v-8a2 2 0 00-4 0v10a2 2 0 002 2h6a2 2 0 000-4z","fill":"#adadad"}})])])
          )
        }
      }
    